import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DialogueBatch from "../Narrative/DialogueBatch";
import UserProgressContext from "../../userProgressContext";

const SecurityAlert = ({ script }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { localProgress } = useContext(UserProgressContext);
  let previousLocationPathname = undefined;
  let crossover = false;
  if (location && location.state) {
    const state = location.state;
    if (state.previousLocationPathname)
      previousLocationPathname = state.previousLocationPathname;
    if (state.crossover) crossover = state.crossover;
  }
  useEffect(() => {
    if (!crossover || !previousLocationPathname) navigate("/page-not-found");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <React.Fragment>
      {script && crossover && script[localProgress] && (
        <DialogueBatch key={localProgress} step={script[localProgress.toString()]} />
      )}
      {script &&
        script[localProgress] &&
        "visuals" in script[localProgress] && (
          <div className="w-full relative flex flex-col md:flex-row justify-center items-center gap-8 mt-4 md:mt-2">
            {script[localProgress]["visuals"].map((visual, id) => (
              <div
                key={id}
                className="w-64 md:w-80 md:h-80 rounded-lg bg-white flex items-center shadow-lg shadow-red-700 animate-pulseShadow"
              >
                <img
                  src={require(`../../static/images/visuals/${visual}.png`)}
                  alt="Computer Screen"
                  className="w-full h-full rounded-lg"
                />
              </div>
            ))}
          </div>
        )}
    </React.Fragment>
  );
};

export default SecurityAlert;
